<template>
  <div class="wrap">
    <menu ref="citiesList">
      <div
        v-if="isViewList"
        class="articles-list-cities"
      >
        <a
          v-for="(el, i) in slicedList"
          :key="i"
          class="articles-list-cities-link"
          :href="goTo(el?.slug)"
          @click.prevent="use(el)"
        >
          {{ el.nameRu }}
        </a>
      </div>
      <div class="btn-wrap">
        <slot
          class="long-btn"
          name="btn"
        />
      </div>
    </menu>
  </div>
</template>

<script lang="ts" setup>
  import { computed } from 'vue';
  import type { GeoItem } from '@/shared/models/journal';
  import { useScreenSize } from '@/shared/utils/breakpoints';

  const breakpoints = useScreenSize();

  const emit = defineEmits<{
    /**
     * Событие клика по элементу.
     *
     * @param item данные элемента
     * @param position позиция в списке
     */
    'item-click': [el: GeoItem, url: string];
  }>();

  interface Props {
    list: GeoItem[];
    maxViewCount?: number;
    linkType: 'city' | 'country' | 'region';
  }

  const props = withDefaults(defineProps<Props>(), {
    maxViewCount: 15,
  });

  const slicedList = computed<GeoItem[]>(() => props.list.slice(0, props.maxViewCount));

  const isViewList = computed<boolean>(() => !(breakpoints.isMobile.value || !props.list.length));

  const goTo = (slug: string): string => {
    if (props.linkType === 'city' || props.linkType === 'region') {
      return `/journal/city/articles/${slug}/`;
    }

    if (props.linkType === 'country') {
      return `/journal/country/articles/${slug}/`;
    }

    return '';
  };

  const use = (el: GeoItem) => {
    emit('item-click', el, goTo(el.slug));
  };
</script>

<style lang="scss" scoped>
  .articles-list-cities {
    --cities-height: 32px;
    position: relative;
    display: flex;
    gap: 24px 16px;
    align-items: center;
    overflow: hidden visible;

    @include tablet {
      min-height: var(--cities-height);
    }
  }

  .articles-list-cities-link {
    color: var(--alias-color-link-default);
    font-size: 24px;
    line-height: 32px;
    text-decoration: none;
    white-space: nowrap;

    &:hover {
      color: var(--alias-color-link-default-hovered);
    }

    @include tablet {
      font-size: 20px;
      line-height: 26px;
    }
  }

  .btn-wrap {
    position: absolute;
    top: 0;
    right: 0;
    background: var(--alias-color-background-default);

    &:before {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      left: -48px;
      width: 48px;
      background: linear-gradient(to right, transparent 0%, var(--alias-color-background-default) 100%);
    }

    @include mobile {
      position: static;
      width: 100%;

      &:before {
        display: none;
      }
    }
  }

  menu {
    position: relative;
  }
</style>
